
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import BottomNavigation from '../../components/feature/BottomNavigation';

export default function ProfilePage() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    const savedCart = localStorage.getItem('cartItems');
    if (savedCart) {
      setCartItems(JSON.parse(savedCart));
    }
  }, []);

  const getTotalCartItems = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };

  const handleLogout = () => {
    localStorage.clear();
    setCartItems([]);
    navigate('/');
  };

  const menuItems = [
    { icon: 'ri-home-line', label: 'الرئيسية', path: '/' },
    { icon: 'ri-grid-line', label: 'الأقسام', path: '/categories' },
    { icon: 'ri-shopping-bag-line', label: 'طلباتي', path: '/orders' },
    { icon: 'ri-shopping-cart-line', label: 'السلة', path: '/cart' },
    { icon: 'ri-user-line', label: 'الملف الشخصي', path: '/profile' },
  ];

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Sidebar Overlay */}
      {showSidebar && (
        <div 
          className="fixed inset-0 bg-black/50 z-40"
          onClick={() => setShowSidebar(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`fixed top-0 right-0 h-full w-80 bg-white shadow-xl z-50 transform transition-transform duration-300 ${
        showSidebar ? 'translate-x-0' : 'translate-x-full'
      }`}>
        <div className="p-6">
          {/* Sidebar Header */}
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-xl font-bold text-[#333333]" dir="rtl">القائمة</h2>
            <button
              onClick={() => setShowSidebar(false)}
              className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center"
            >
              <i className="ri-close-line text-gray-600"></i>
            </button>
          </div>

          {/* User Info */}
          <div className="bg-[#D4AF37]/10 rounded-xl p-4 mb-6" dir="rtl">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center ml-3">
                <i className="ri-user-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#333333]">أحمد محمد</h3>
                <p className="text-sm text-[#777777]">ahmed@example.com</p>
              </div>
            </div>
          </div>

          {/* Menu Items */}
          <nav className="space-y-2">
            {menuItems.map((item, index) => (
              <button
                key={index}
                onClick={() => {
                  navigate(item.path);
                  setShowSidebar(false);
                }}
                className="w-full flex items-center p-3 rounded-lg hover:bg-gray-50 transition-colors"
                dir="rtl"
              >
                <i className={`${item.icon} text-[#D4AF37] text-xl ml-3`}></i>
                <span className="font-medium text-[#333333]">{item.label}</span>
              </button>
            ))}
          </nav>

          {/* Logout Button */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <button
              onClick={handleLogout}
              className="w-full flex items-center p-3 rounded-lg text-red-500 hover:bg-red-50 transition-colors"
              dir="rtl"
            >
              <i className="ri-logout-box-line text-xl ml-3"></i>
              <span className="font-medium">تسجيل الخروج</span>
            </button>
          </div>
        </div>
      </div>

      <Header 
        cartItemsCount={getTotalCartItems()} 
        onMenuClick={() => setShowSidebar(true)}
      />
      
      <main className="pt-16 pb-32">
        {/* Profile Header */}
        <div className="bg-white p-6 mb-6">
          <div className="flex items-center" dir="rtl">
            <div className="w-20 h-20 bg-[#D4AF37] rounded-full flex items-center justify-center ml-4">
              <i className="ri-user-line text-white text-3xl"></i>
            </div>
            <div>
              <h1 className="text-xl font-bold text-[#333333] mb-1">أحمد محمد</h1>
              <p className="text-[#777777]">ahmed@example.com</p>
              <p className="text-sm text-[#777777]">عضو منذ يناير 2024</p>
            </div>
          </div>
        </div>

        {/* Profile Stats */}
        <div className="px-4 mb-6">
          <div className="grid grid-cols-3 gap-4">
            <div className="bg-white rounded-xl p-4 text-center">
              <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-shopping-bag-line text-[#D4AF37] text-xl"></i>
              </div>
              <p className="text-2xl font-bold text-[#333333]">12</p>
              <p className="text-sm text-[#777777]">طلب</p>
            </div>
            
            <div className="bg-white rounded-xl p-4 text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-heart-line text-green-500 text-xl"></i>
              </div>
              <p className="text-2xl font-bold text-[#333333]">8</p>
              <p className="text-sm text-[#777777]">مفضل</p>
            </div>
            
            <div className="bg-white rounded-xl p-4 text-center">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-star-line text-blue-500 text-xl"></i>
              </div>
              <p className="text-2xl font-bold text-[#333333]">4.8</p>
              <p className="text-sm text-[#777777]">تقييم</p>
            </div>
          </div>
        </div>

        {/* Profile Menu */}
        <div className="px-4">
          <div className="bg-white rounded-xl overflow-hidden">
            <button
              onClick={() => navigate('/orders')}
              className="w-full flex items-center justify-between p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors"
              dir="rtl"
            >
              <div className="flex items-center">
                <div className="w-10 h-10 bg-[#D4AF37]/10 rounded-full flex items-center justify-center ml-3">
                  <i className="ri-shopping-bag-line text-[#D4AF37]"></i>
                </div>
                <span className="font-medium text-[#333333]">طلباتي</span>
              </div>
              <i className="ri-arrow-left-s-line text-[#777777]"></i>
            </button>

            <button className="w-full flex items-center justify-between p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors" dir="rtl">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center ml-3">
                  <i className="ri-heart-line text-red-500"></i>
                </div>
                <span className="font-medium text-[#333333]">المفضلة</span>
              </div>
              <i className="ri-arrow-left-s-line text-[#777777]"></i>
            </button>

            <button className="w-full flex items-center justify-between p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors" dir="rtl">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center ml-3">
                  <i className="ri-map-pin-line text-blue-500"></i>
                </div>
                <span className="font-medium text-[#333333]">العناوين</span>
              </div>
              <i className="ri-arrow-left-s-line text-[#777777]"></i>
            </button>

            <button className="w-full flex items-center justify-between p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors" dir="rtl">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center ml-3">
                  <i className="ri-notification-line text-green-500"></i>
                </div>
                <span className="font-medium text-[#333333]">الإشعارات</span>
              </div>
              <i className="ri-arrow-left-s-line text-[#777777]"></i>
            </button>

            <button className="w-full flex items-center justify-between p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors" dir="rtl">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center ml-3">
                  <i className="ri-settings-line text-purple-500"></i>
                </div>
                <span className="font-medium text-[#333333]">الإعدادات</span>
              </div>
              <i className="ri-arrow-left-s-line text-[#777777]"></i>
            </button>

            <button className="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors" dir="rtl">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center ml-3">
                  <i className="ri-customer-service-line text-orange-500"></i>
                </div>
                <span className="font-medium text-[#333333]">الدعم الفني</span>
              </div>
              <i className="ri-arrow-left-s-line text-[#777777]"></i>
            </button>
          </div>
        </div>

        {/* Logout Button */}
        <div className="px-4 mt-6">
          <button
            onClick={handleLogout}
            className="w-full bg-red-500 text-white py-4 rounded-xl font-bold hover:bg-red-600 transition-colors"
          >
            تسجيل الخروج
          </button>
        </div>
      </main>

      <BottomNavigation />
    </div>
  );
}
